<template>
  <div
    :class="type == 'register' ? 'Login isRegister' : 'Login noRegister'"
    v-if="to_login == false"
  >
    <div class="language">
      <!-- <el-dropdown @command="checkoutLanguage">
        <span>
          <img src="../../assets/images/international.png"/>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="cn">简体中文</el-dropdown-item>
          <el-dropdown-item command="en">English</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
    </div>
    <!-- pc端登陆 -->
    <div class="logo">
      <img src="../../assets/images/kailei_logo.png" />
      <p>Kerry Cloud</p>
      <div class="xcxqrcode" @click="showQrcode = true">
        <el-popover
          placement="bottom"
          popper-class="popover"
          v-model="showQrcode"
        >
          <div style="display:flex;">
            <div class="wxQrcodes">
              <div class="images">
                <img
                  src="../../assets/images/xcxqrcode.jpg"
                  alt
                  class="qrcodes"
                />
              </div>
              <P>微信小程序</P>
            </div>
            <!-- <div class="wxQrcodes">
              <div class="images">
                <img src="https://yliiotcloud.obs.cn-east-3.myhuaweicloud.com/58071675148623_.pic.jpg" alt class="qrcodes" />
              </div>
              <P>Android</P>
            </div>
            <div class="wxQrcodes">
              <div class="images">
                <img src="../../assets/images/logo.jpg" alt class="qrcodes" />
              </div>
              <P>App Store搜索"kerryCloud"</P>
            </div> -->
          </div>
          <img src="../../assets/images/icon_ewm.png" slot="reference" />
        </el-popover>
      </div>
    </div>
    <div class="form" v-show="type == 'pc'">
      <h1 class="logTxt">Welcome</h1>
      <div class="line">
        <div class="leftCircular"></div>
        <div class="centerLine"></div>
        <div class="rightCircular"></div>
      </div>
      <div class="login">
        <!-- <el-form :model="ruleFormLogin" ref="login">
          <el-form-item prop="username">
            <el-input
              placeholder="请输入邮箱账号"
              class="yl-input"
              v-model="ruleFormLogin.username"
            >
              <i slot="prefix" class="el-input__icon el-icon-yxzh"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              class="yl-input"
              placeholder="请输入密码"
              v-model="ruleFormLogin.password"
              @keyup.enter.native="login"
            >
              <i slot="prefix" class="el-input__icon el-icon-mmgl"></i>
            </el-input>
          </el-form-item>
        </el-form> -->
        <div style="position: relative;"></div>
        <div class="bottom">
          <el-button type="primary" @click="login">返回登录</el-button>
        </div>
        <!-- <div class="register">
          <el-button type="text" @click="type='register'">点击注册</el-button>
        </div> -->
      </div>
    </div>
    <div class="footer">
      <p>Copyright 2022 上海恺雷自控系统有限公司 保留所有权利.v1.6.10</p>
    </div>
  </div>
</template>
<script>
import LoginService from "@/api/login";
import { utils } from "@/utils/index.js";
import { Loading } from "element-ui";
// import FloatLayer from "../../components/floatLayer";
export default {
  // components: {
  //   FloatLayer,
  // },
  data() {
    return {
      to_login: false, //判断是否是官网跳转
      code: "",
      appid: "wx59fe8a017f4bfa7a",
      showQrcode: false,
      ruleFormLogin: {
        //登录账号
        username: "",
        password: "",
      },
      type: "pc",
      remember: false,
    };
  },
  methods: {
    // wxLogin(){
    //   window.location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=wx59fe8a017f4bfa7a&redirect_uri=https://cloud.yliiot.com/wxCallback/scanCodeLogin&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect'
    // },
    //通过code获取token
    getoken() {
      LoginService.getTokenAccordingToCode({
        code: this.code,
      })
        .then((res) => {
          this.$store.dispatch("setToken", res.data.access_token);
          this.$store.dispatch("setUser_id", res.data.user_id);
          this.$router.push("/home");
          this.$message.success("登录成功");
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 登录
    login() {
      window.open("https://kac.51kerry.cn/index", "_self");
      // this.$refs.login.validate((vaild) => {
      //   if (vaild) {
      //     LoginService.login({
      //       username: this.ruleFormLogin.username,
      //       password: this.$Base64.encode(this.ruleFormLogin.password),
      //     })
      //       .then((res) => {
      //         this.$store.dispatch("setToken", res.data.user_token);
      //         this.$store.dispatch("setUser_id", res.data.user_id);
      //         this.$store.dispatch("setUsername", res.data.real_name);
      //         sessionStorage.setItem("is_admin", res.data.is_admin);
      //         sessionStorage.setItem("is_update_data", res.data.is_update_data);
      //         sessionStorage.setItem("company", res.data.company);
      //         sessionStorage.setItem("mobile", res.data.mobile);
      //         sessionStorage.setItem("real_name", res.data.real_name);
      //         sessionStorage.setItem("address", res.data.address);
      //         this.setUserInfo();
      //         this.$router.push("/home");
      //         this.$message.success("登录成功");
      //       })
      //       .catch((err) => {
      //         this.$message.error(err.message);
      //       });
      //   } else {
      //     this.$message.error("请检查必填项");
      //     return false;
      //   }
      // });
    },

    // 储存表单信息
    setUserInfo() {
      // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
      // 如果没有勾选，储存的信息为空
      console.log(this.remember);
      if (this.remember) {
        this.setCookie("account", this.ruleFormLogin.username, 10);
        // base64加密密码
        let passWord = this.$Base64.encode(this.ruleFormLogin.password);
        this.setCookie("password", passWord, 10);
        this.setCookie("remember", this.remember, 10);
      } else {
        this.setCookie("account", "");
        this.setCookie("password", "");
      }
    },
    // 获取cookie
    getCookie(key) {
      if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(key + "=");
        if (start !== -1) {
          start = start + key.length + 1;
          var end = document.cookie.indexOf(";", start);
          if (end === -1) end = document.cookie.length;
          return unescape(document.cookie.substring(start, end));
        }
      }
      return "";
    },
    // 保存cookie
    setCookie(cName, value, expiredays) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + expiredays);
      document.cookie =
        cName +
        "=" +
        decodeURIComponent(value) +
        (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
    },
  },
  created() {
    let _this = this;
    if (window.location.href.indexOf("cookie") != -1) {
      this.to_login = true;
      this.$store.dispatch("setToken", _this.getCookie("user_token"));
      this.$store.dispatch("setUser_id", _this.getCookie("user_id"));
      this.$store.dispatch("setUsername", _this.getCookie("real_name"));
      sessionStorage.setItem("is_admin", _this.getCookie("is_admin"));
      sessionStorage.setItem(
        "is_update_data",
        _this.getCookie("is_update_data")
      );
      sessionStorage.setItem("company", _this.getCookie("company"));
      sessionStorage.setItem("mobile", _this.getCookie("mobile"));
      sessionStorage.setItem("real_name", _this.getCookie("real_name"));
      sessionStorage.setItem("address", _this.getCookie("address"));
      this.$router.push("/home");
    } else {
      window.open("https://kac.51kerry.cn/index", "_self");
    }
    if (window.location.href.indexOf("code") != -1) {
      let loading = Loading.service({
        text: "登录中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.code = utils.getParams("code", window.location.href);
      this.getoken();
      loading.close();
    }
    // 在页面加载时从cookie获取登录信息
    let account = this.getCookie("account");
    let password = this.$Base64.decode(this.getCookie("password"));
    // 如果存在赋值给表单，并且将记住密码勾选
    if (account) {
      this.ruleFormLogin.username = account;
      this.ruleFormLogin.password = password;
      this.remember = true;
    }
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.isRegister {
  background: url("https://yliiotcloud.obs.cn-east-3.myhuaweicloud.com/22271653304952_.pic_hd.jpg")
    repeat;
}
.noRegister {
  background: url("https://yliiotcloud.obs.cn-east-3.myhuaweicloud.com/22261653304932_.pic_hd.jpg")
    repeat;
}
.Login {
  background-position: center;
  height: 100vh;
  width: 100vw;
  background-size: cover;
  position: relative;
  .form,
  .wxLogin,
  .forgetPassword {
    width: 526px;
    height: 500px;
    background: url("../../assets/images/Frame_dl1.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    padding: 0 55px;
    right: 180px;
    top: 197px;
    .line {
      width: 150px;
      height: 10px;
      display: flex;
      align-items: center;
      margin-left: 130px;
      margin-bottom: 25px;
      .leftCircular {
        width: 8px;
        height: 8px;
        border: 2px solid #00c0ff;
        border-radius: 50%;
      }
      .centerLine {
        width: 140px;
        height: 1px;
        background: #00c0ff;
        border-radius: 0px;
      }
      .rightCircular {
        width: 8px;
        height: 8px;
        border: 2px solid #00c0ff;
        border-radius: 50%;
      }
    }
    .qrcode {
      position: absolute;
      top: 28px;
      right: 10px;
      cursor: pointer;
      display: flex;
      height: 22px;
      align-items: center;
      width: 152px;
      height: 64px;
      padding-left: 10px;
      img {
        width: 16px;
      }
      p {
        margin-left: 9px;
        font-family: PingFang SC;
        color: #ffffff;
      }
    }
  }
}
.bottom {
  .el-button {
    margin-top: 60px;
    margin-left: 23px;
    width: 370px;
    height: 50px;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    background: #00c0ff;
  }
}
.register {
  margin-top: 7px;
  text-align: center;
  .el-button {
    color: #fff;
    font-size: 16px;
    font-family: PingFang SC;
  }
}
.wxLogin {
  .qrcode {
    padding-left: 25px !important;
  }
  .line {
    width: 250px !important;
    margin-left: 80px !important;
    .centerLine {
      width: 240px !important;
    }
  }
  div {
    width: 100%;
    text-align: center;
    img {
      width: 128px;
    }
    .passwordLogin {
      position: absolute;
      bottom: 7%;
      left: 0;
      right: 0;
      .el-button {
        font-family: PingFang SC;
        color: #ffffff;
      }
    }
  }
}
.forgetPassword {
  background: url("../../assets/images/Frame_dl2.png") no-repeat !important;
  background-size: 100% 100% !important;
  .logTxt {
    margin-top: 56px !important;
  }
}
.logTxt {
  font-size: 26px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  margin-bottom: 8px;
  margin-top: 106px;
}
.registers {
  width: 526px;
  height: 750px;
  background-color: #ffffff;
  padding: 0 55px;
  position: absolute;
  top: 67px;
  right: 180px;
  background: url("../../assets/images/Frame_zcy.png") no-repeat;
  background-size: 100% 100%;
  .logTxt {
    margin-top: 84px !important;
  }
  .line {
    width: 150px;
    height: 10px;
    display: flex;
    align-items: center;
    margin-left: 130px;
    margin-bottom: 25px;
    .leftCircular {
      width: 8px;
      height: 8px;
      border: 2px solid #00c0ff;
      border-radius: 50%;
    }
    .centerLine {
      width: 140px;
      height: 1px;
      background: #00c0ff;
      border-radius: 0px;
    }
    .rightCircular {
      width: 8px;
      height: 8px;
      border: 2px solid #00c0ff;
      border-radius: 50%;
    }
  }
}
.w-358 {
  width: 296px;
  margin-right: 10px;
}
.complete {
  margin-left: 23px;
  background: rgba(0, 190, 255, 0.9);
  width: 370px;
  height: 50px;
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: bold;
}
.back {
  margin-left: 45% !important;
  font-size: 16px;
  color: #fff;
}
.registerBottom {
  .el-button {
    margin-top: 20px;
    margin-left: 23px;
    background: rgba(0, 190, 255, 0.9);
    width: 370px;
    height: 50px;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: bold;
  }
}
.footer {
  width: 100%;
  height: 40px;
  position: absolute;
  bottom: 0;
  user-select: none;
  p {
    text-align: center;
    color: #ffffff;
    font-size: 16px;
  }
}
.language {
  width: 30px;
  height: 60px;
  position: absolute;
  top: 30px;
  right: 30px;
  img {
    width: 26px;
    height: 26px;
    text-align: center;
    cursor: pointer;
  }
}
.logo {
  width: 450px;
  height: 100px;
  position: absolute;
  top: 40px;
  left: 100px;
  display: flex;
  align-items: center;
  img {
    width: 60px;
    height: 40px;
    margin-right: 10px;
  }
  p {
    font-size: 40px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    line-height: 61px;
  }
  .xcxqrcode {
    width: 40px;
    height: 40px;
    margin-left: 48px;
    .popover {
      width: 160px;
    }
    img {
      width: 100%;
      cursor: pointer;
    }
  }
}
.send_yzm {
  position: absolute;
  right: 0;
  width: 100px;
  height: 40px;
  font-size: 18px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  padding-left: 6px;
  background: linear-gradient(90deg, #00eaff, #00c0ff);
}
.toLogin {
  margin-top: 7px;
  text-align: center;
  font-family: PingFang SC;
  span {
    color: #ffffff;
  }
  .el-button {
    font-size: 16px;
    color: #00c0ff;
  }
}
.cover {
  .img p {
    text-align: center;
  }
  .qrcode {
    width: 260px;
    height: 260px;
  }
  .close {
    width: 32px;
    height: 32px;
    margin-top: 24px;
    cursor: pointer;
  }
}
.qrcodes {
  // margin-left: 6px;
  width: 120px;
  height: 120px;
}
.wxQrcodes {
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin:0 10px;
  width: 180px;
  .images {
    width: 120px;
    .qrcodes {
      // margin-left: 6px;
      width: 100%;
    }
  }

  p {
    margin-top: 10px;
    // font-size: 22px;
    // font-weight: 700;
  }
}
.rember {
  display: inline-block;
  font-size: 16px;
  height: 22px;
  line-height: 22px;
  margin-right: 5px;
  font-family: PingFang SC;
  color: #fff;
  margin-left: 10px;
}
.wx_box {
  width: 100px;
  height: 200px;
}
</style>
